// components/common/Container.js
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;

  @media (max-width: 1240px) {
    max-width: 960px;
  }

  @media (max-width: 992px) {
    max-width: 720px;
  }

  @media (max-width: 768px) {
    max-width: 540px;
  }

  @media (max-width: 576px) {
    max-width: 100%;
    padding: 0 1.5rem;
    box-sizing: border-box;
  }

  ${props => props.narrow && `
    max-width: 800px;
  `}

  ${props => props.wide && `
    max-width: 1400px;
  `}
`;

export default Container;
